import { QrCode, Zap } from "lucide-react";
import { Loading, EmptyArt } from "@/components/mobile/parts";
import { DeliveryCard } from "@/pages/mobile/MDelivery";
import { usePoll } from "@/hooks/useMobileData";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export function MenuOrdersTab() {
  const { session } = useAuth();
  const auto = session.tenant.settings.delivery_auto_accept;
  const { data, load } = usePoll(() => api.get("/orders").then((r) => r.data.filter((o) => o.status === "recebido")), 8000);
  return (
    <div className="space-y-2.5">
      {auto && <p className="flex items-start gap-2 rounded-xl bg-amber-100 p-3 text-xs text-amber-900" data-testid="m-auto-accept-note"><Zap className="h-4 w-4 shrink-0" />O aceite automático está ligado: os pedidos do cardápio vão direto para a cozinha. Só aparecem aqui os que ficaram aguardando (ex.: pagamento online pendente).</p>}
      <p className="text-xs text-slate-500">Pedidos do cardápio digital e do delivery que ainda não foram para a cozinha.</p>
      {!data ? <Loading /> : !data.length ? <EmptyArt icon={QrCode} title="Nenhum pedido aguardando" testId="m-menu-orders-empty" />
        : data.map((o) => <DeliveryCard key={o.id} o={o} onChange={load} approvalMode />)}
    </div>
  );
}
